import React, { useState } from 'react';

const nasalCannulaSkills = [
  { id: 1, objective: 'Attach Nasal Cannula to Regulator', notes: ['To Christmas Tree Adapter (CTA)'], critical: false },
  { id: 2, objective: 'State dose of Oxygen to be administered', notes: ['1-6 LPM'], critical: true },
  { id: 3, objective: 'State O2% of Nasal Cannula', notes: ['24-44%'], critical: false },
  { id: 4, objective: 'Place patient on Nasal Cannula', notes: ['With prongs facing correctly in the nose, then wrapping the ears'], critical: false },
];

const creditOptions = [
  { label: 'Full', value: 'full' },
  { label: 'Partial', value: 'partial' },
  { label: 'None', value: 'none' },
];

const CreditBox = ({ selected, type }) => {
  let boxClass = 'w-8 h-8 rounded border-2 border-primary cursor-pointer flex items-center justify-center';
  let inner = null;
  if (selected) {
    if (type === 'full') {
      inner = <div className="w-6 h-6 bg-green-400 rounded" />;
    } else if (type === 'partial') {
      inner = (
        <div className="w-6 h-6 bg-white rounded flex flex-col overflow-hidden">
          <div className="h-1/2 w-full bg-white" />
          <div className="h-1/2 w-full bg-green-400" />
        </div>
      );
    } else if (type === 'none') {
      inner = <div className="w-6 h-6 bg-red-400 rounded" />;
    }
  }
  return (
    <div className={boxClass}>{inner}</div>
  );
};

const NasalCannulaForm = () => {
  const [credit, setCredit] = useState(Array(nasalCannulaSkills.length).fill(''));

  return (
    <div className="min-h-screen bg-bg text-text flex flex-col items-center py-8">
      <h1 className="text-2xl font-bold mb-2 text-primary">Nasal Cannula</h1>
      <h2 className="text-lg font-semibold mb-4 text-secondary">Skill Sheet</h2>
      <table className="w-full max-w-2xl table-auto mb-4 border border-gray-400 rounded-xl bg-table shadow">
        <thead>
          <tr className="bg-gradient-to-r from-primary/80 to-secondary/80 text-bg">
            <th className="p-2 bg-tableRow text-text">STUDENT OBJECTIVES</th>
            <th className="p-2 bg-tableRow text-text">INSTRUCTOR NOTES</th>
            <th className="p-2 bg-tableRow text-text" colSpan={3}>CREDIT</th>
          </tr>
          <tr className="bg-tableRow text-text">
            <th colSpan={2}></th>
            <th className="text-center font-semibold">Full</th>
            <th className="text-center font-semibold">Half</th>
            <th className="text-center font-semibold">None</th>
          </tr>
        </thead>
        <tbody>
          {nasalCannulaSkills.map((skill, idx) => (
            <tr key={skill.id} className="bg-tableRow text-text border-b border-gray-300 last:border-0">
              <td className={`p-2 align-middle${skill.critical ? ' text-red-600 font-bold' : ''}`}>{idx + 1}. {skill.objective}</td>
              <td className="p-2 align-middle">{skill.notes.join(', ')}</td>
              <td className="p-2 align-middle text-center">
                <button
                  type="button"
                  className="focus:outline-none"
                  onClick={() => setCredit(credit.map((c, i) => i === idx ? 'full' : c))}
                  aria-label="Full Credit"
                >
                  <CreditBox selected={credit[idx] === 'full'} type="full" />
                </button>
              </td>
              <td className="p-2 align-middle text-center">
                <button
                  type="button"
                  className="focus:outline-none"
                  onClick={() => setCredit(credit.map((c, i) => i === idx ? 'partial' : c))}
                  aria-label="Half Credit"
                >
                  <CreditBox selected={credit[idx] === 'partial'} type="partial" />
                </button>
              </td>
              <td className="p-2 align-middle text-center">
                <button
                  type="button"
                  className="focus:outline-none"
                  onClick={() => setCredit(credit.map((c, i) => i === idx ? 'none' : c))}
                  aria-label="No Credit"
                >
                  <CreditBox selected={credit[idx] === 'none'} type="none" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default NasalCannulaForm;
